export default {
      id: "callout-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#callout",
      toString: function () {
        return this.url;
      }
    }